import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "types/store";
import { Button } from "aible";
import closeIconPurple from "images/CloseIconPurple.svg";
import checkedBox from "images/Square Check Icon.svg";
import uncheckedBox from "images/Square Light.svg";
import uncheckedBoxGray from "images/Square Light gray.svg";
import filesLightPurpleIcon from "images/Files Light Purple.svg";
import circlePlusLightIcon from "images/circle-plus-light-purple.svg";
import styles from "./style.module.css";
import { CHATAIBLE_BLUEPRINTS, CHATAIBLE_SQL } from "containers/ChatGPT/reducer";
import { BlueprintPopup } from "components/ChatGPT/ChatGPT";
import { AttachContextButton } from "components/NewChat/ContextSelectionPanel";
import * as nextReducer from "containers/Next/NextReducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as languageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";
import * as viewReducer from "containers/View/reducer";
import * as globalReducer from "containers/App/reducer";
import { isEnabled } from "utils/featureFlags";
import LinkedComparisonSelect from "../Next/Dashboard/LinkedComparisonSelect";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
const AddContextButton = ({ nextId, isDisabled, isChatTemplate }) => {
    const dispatch = useDispatch();
    const currentNextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const retNextId = nextId ?? currentNextId ?? "new";
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, retNextId));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const documentSet = useSelector((state) => languageModelArtifactReducer.getCorpus(state, artifactId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const promptAttachments = useSelector(chatGPTReducer.getPromptAttachments);
    const updateDatasetId = (val) => dispatch(nextReducer.updateDatasetId(retNextId, val));
    const updateArtifactId = (val) => dispatch(chatGPTReducer.updateArtifactId(val));
    const selectBlueprint = (val) => dispatch(chatGPTReducer.selectBlueprint(val));
    const contextSelectionPanelTab = useSelector((state) => chatGPTReducer.getContextSelectionPanelTab(state));
    const updateContextSelectionPanelTab = (val) => dispatch(chatGPTReducer.updateContextSelectionPanelTab(val));
    const updateNewChatKPIPanel = (val) => dispatch(chatGPTReducer.updateNewChatKPIPanel(val));
    const hasDocumentSelected = chatType === "DOCUMENT" && Boolean(documentSet);
    const hasDatasetSelected = (chatType === "SQL" || chatType === "AIBLE" || chatType === "WHATS_CHANGED" || chatType === "KPI_ANALYSIS") &&
        Boolean(dataset);
    const hasPromptAttachments = promptAttachments !== undefined && Object.keys(promptAttachments).length > 0;
    const hasNoneSelected = !hasDatasetSelected && !hasDocumentSelected && !hasPromptAttachments;
    const sourceDisplay = useSelector((state) => homeReducer.getDatasetSourceDisplayFromState(state, datasetId));
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const isChatApp = chatApp?.id !== undefined;
    const chatAppDataset = chatApp?.wizard?.steps?.[0]?.datasetId;
    const chatAppDocumentset = chatApp?.wizard?.steps?.[0]?.artifactId;
    const requireDatasetConfirmation = hasDatasetSelected && datasetId === chatAppDataset;
    const requireDocumentConfirmation = hasDocumentSelected && artifactId === chatAppDocumentset;
    const [showConfirmationModal, updateShowConfirmationModal] = useState(false);
    const [confirmationAction, updateConfirmationAction] = useState(undefined);
    const [hasConfirmed, updateHasConfirmed] = useState(false);
    const requireConfirmation = (requireDatasetConfirmation || requireDocumentConfirmation) && isChatApp && !isChatTemplate && !hasConfirmed;
    const handleRemoveContext = () => {
        updateNewChatKPIPanel(false);
        updateArtifactId(undefined);
        updateDatasetId(undefined);
        dispatch(chatGPTReducer.updatePromptAttachments(undefined));
        // Updating so that removing context on existing projects goes back to dataset search
        if (retNextId !== "new") {
            selectBlueprint("CHATAIBLE_DATA_SEARCH");
        }
        else if (blueprintId === CHATAIBLE_BLUEPRINTS.CHATAIBLE_ANALYTICS.id || blueprintId === CHATAIBLE_SQL.id) {
            selectBlueprint("CHATAIBLE_RAW_CHAT");
        }
    };
    const handleAddContext = () => {
        updateNewChatKPIPanel(false);
        if (!contextSelectionPanelTab) {
            updateContextSelectionPanelTab(isEnabled("spark-with-partners") ? "DOCUMENT" : "DATA");
        }
        else {
            updateContextSelectionPanelTab(undefined);
        }
    };
    const retDisable = isDisabled;
    if (!hasPromptAttachments && !hasDocumentSelected && isEnabled("spark-with-partners")) {
        return (React.createElement(AttachContextButton, { type: "secondary", style: { marginRight: "12px" } },
            React.createElement("div", { className: styles.dataButtonIconContainer },
                React.createElement("div", { className: styles.dataButtonIcon },
                    React.createElement("img", { src: circlePlusLightIcon, style: retDisable ? { filter: "saturate(0%) brightness(150%)" } : undefined }))),
            React.createElement("div", { className: styles.contextButtonLabel }, "Attach File")));
    }
    return (React.createElement(Button, { onClick: () => {
            if (requireConfirmation) {
                updateShowConfirmationModal(!showConfirmationModal);
                updateConfirmationAction("ADD");
            }
            else {
                handleAddContext();
            }
        }, active: Boolean(contextSelectionPanelTab) || hasDatasetSelected || hasDocumentSelected, disabled: retDisable, className: styles.dataButton, style: { marginRight: "10px" } },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.dataButtonIconContainer },
                hasNoneSelected && (React.createElement("div", { className: styles.dataButtonIcon },
                    React.createElement("img", { src: circlePlusLightIcon, style: retDisable ? { filter: "saturate(0%) brightness(150%)" } : undefined }))),
                (hasDocumentSelected || hasPromptAttachments) && (React.createElement("div", { className: styles.dataButtonIcon },
                    React.createElement("img", { src: filesLightPurpleIcon, style: retDisable ? { filter: "saturate(0%) brightness(150%)" } : undefined }))),
                hasDatasetSelected && (React.createElement("div", { className: styles.dataButtonIcon },
                    React.createElement("img", { src: sourceDisplay?.iconGray, style: retDisable ? { filter: "saturate(0%) brightness(150%)" } : undefined })))),
            React.createElement("div", { className: styles.contextButtonLabel }, hasDocumentSelected
                ? documentSet?.name
                : hasDatasetSelected
                    ? dataset?.name
                    : hasPromptAttachments
                        ? Object.keys(promptAttachments ?? {})[0]
                        : "Add context"),
            (hasDocumentSelected || hasDatasetSelected || hasPromptAttachments) && (React.createElement("div", { className: styles.dataButtonIcon, style: { marginLeft: "10px", width: "20px", height: "20px" }, onClick: (e) => {
                    e.stopPropagation();
                    if (!retDisable) {
                        if (requireConfirmation) {
                            updateShowConfirmationModal(!showConfirmationModal);
                            updateConfirmationAction("REMOVE");
                        }
                        else {
                            handleRemoveContext();
                        }
                    }
                } },
                React.createElement("img", { src: closeIconPurple, style: retDisable ? { padding: "3px", filter: "saturate(0%) brightness(150%)" } : { padding: "3px" } })))),
        showConfirmationModal && (React.createElement(ConfirmationModal, { showModal: showConfirmationModal, updateShowModal: updateShowConfirmationModal, confirmationAction: confirmationAction, updateConfirmationAction: updateConfirmationAction, handleAddContext: handleAddContext, handleRemoveContext: handleRemoveContext, updateHasConfirmed: updateHasConfirmed }))));
};
const ContextSelectionButtons = ({ nextId, checkFolderData, nlqDashFooter, checkAgentAutonomy, setShowDaterange, showDaterange, isChatTemplate }) => {
    const dispatch = useDispatch();
    const currentNextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const retNextId = nextId ?? currentNextId ?? "new";
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const showBlueprintMessage = useSelector((state) => chatGPTReducer.getShowBlueprintMessage(state));
    const selectBlueprint = (val) => dispatch(chatGPTReducer.selectBlueprint(val));
    const updateContextSelectionPanelTab = (val) => dispatch(chatGPTReducer.updateContextSelectionPanelTab(val));
    const updateDatasetId = (val) => dispatch(nextReducer.updateDatasetId(retNextId, val));
    const updateArtifactId = (val) => dispatch(chatGPTReducer.updateArtifactId(val));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, retNextId));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const documentSet = useSelector((state) => languageModelArtifactReducer.getCorpus(state, artifactId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const hasDocumentSelected = chatType === "DOCUMENT" && Boolean(documentSet);
    const hasDatasetSelected = (chatType === "SQL" || chatType === "AIBLE" || chatType === "WHATS_CHANGED" || chatType === "KPI_ANALYSIS") &&
        Boolean(dataset);
    const promptAttachments = useSelector(chatGPTReducer.getPromptAttachments);
    const hasPromptAttachments = promptAttachments !== undefined && Object.keys(promptAttachments).length > 0;
    const hasNoneSelected = !hasDatasetSelected && !hasDocumentSelected && !hasPromptAttachments;
    const agentAutonomyView = useSelector((state) => viewReducer.getAgentAutonomyView(state));
    const agentAutonomyEnabled = agentAutonomyView !== "LOW";
    const sparkWithPartnersEnabled = isEnabled("spark-with-partners");
    const agentIqSelectedWithControlsEnabled = isEnabled("agent-autonomy-controls") && blueprintId === "AGENT_IQ";
    const showAutoRecommend = agentAutonomyEnabled && !sparkWithPartnersEnabled && hasNoneSelected && !agentIqSelectedWithControlsEnabled;
    const selectedBlueprint = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const isDatasetsLoading = useSelector((state) => globalReducer.getIsDatasetsLoading(state));
    const isArtifactsLoading = useSelector((state) => globalReducer.getIsArtifactsLoading(state));
    const datasetsList = useSelector((state) => viewReducer.getRawDatasets(state));
    const documentsList = useSelector((state) => languageModelArtifactReducer.getArtifactList(state, "CORPUS"));
    const hasFolderData = documentsList?.length > 0 || datasetsList?.length > 0;
    useEffect(() => {
        if (checkAgentAutonomy && isEnabled("chat-agent-iq") && agentAutonomyView === "HIGH") {
            selectBlueprint("AGENT_IQ");
        }
        else {
            if (checkFolderData === true) {
                if (!hasFolderData && selectedBlueprint === "CHATAIBLE_DATA_SEARCH") {
                    selectBlueprint("CHATAIBLE_RAW_CHAT");
                }
                else if (hasFolderData && selectedBlueprint === "CHATAIBLE_RAW_CHAT" && hasNoneSelected) {
                    selectBlueprint("CHATAIBLE_DATA_SEARCH");
                }
            }
        }
    }, [isDatasetsLoading, isArtifactsLoading]);
    const linkedComparisonProjects = useSelector((state) => nextReducer.getLinkedComparisonProjects(state, nextId)) ?? {};
    const hasLinkedComparisonProjects = Object.keys(linkedComparisonProjects).length > 0;
    const isAutoRecommendLinkedComparison = useSelector((state) => nextReducer.getIsAutoRecommendLinkedComparison(state, nextId));
    const comparisonOptions = useSelector((state) => nextReducer.getComparisonOptions(state, nextId));
    const datasetFields = Object.values(dataset?.fields ?? {});
    const retDatasetFields = dataset?.ranked_fields ?? datasetFields;
    const datasetDateOptions = retDatasetFields.filter((f) => f.type === "date");
    const canShowDaterange = (chatType === "WHATS_CHANGED" || chatType === "KPI_ANALYSIS") &&
        Boolean(datasetDateOptions?.length || comparisonOptions?.dateField) &&
        Boolean(dataset);
    return (React.createElement("div", { className: styles.dataButtonContainer },
        React.createElement("div", { className: styles.dataButtonPopHolder },
            showBlueprintMessage && (React.createElement(BlueprintPopup, { handleClose: () => {
                    dispatch(chatGPTReducer.updateShowBlueprintMessage(false));
                }, onClick: () => {
                    console.log("click");
                    dispatch(chatGPTReducer.selectBlueprint(CHATAIBLE_SQL.id));
                } })),
            hasLinkedComparisonProjects ? (React.createElement("div", { className: styles.linkedComparisonButtons },
                React.createElement("div", { className: styles.linkedComparisonSelect },
                    React.createElement(LinkedComparisonSelect, { isChat: true, id: retNextId, menuPlacement: "top", disabled: isAutoRecommendLinkedComparison })),
                React.createElement(Button, { active: isAutoRecommendLinkedComparison, className: styles.linkedAutoRecommend, onClick: () => dispatch(nextReducer.updateIsAutoRecommendLinkedComparison(nextId, !isAutoRecommendLinkedComparison)) },
                    React.createElement("input", { type: "checkbox", checked: isAutoRecommendLinkedComparison, className: styles.autoRecommendCheckbox }),
                    "Auto-recommend context"))) : (agentAutonomyView !== "LOW" && (React.createElement(AddContextButton, { nextId: nextId, isDisabled: !isChatTemplate && nlqDashFooter, isChatTemplate: isChatTemplate })))),
        canShowDaterange && (React.createElement(Button, { type: "secondary", active: showDaterange, onClick: () => setShowDaterange(!showDaterange), style: { marginRight: "10px" } }, "Date Range")),
        showAutoRecommend && !hasLinkedComparisonProjects && (React.createElement(Button, { onClick: () => {
                if (blueprintId === "CHATAIBLE_DATA_SEARCH") {
                    selectBlueprint("CHATAIBLE_RAW_CHAT");
                }
                else {
                    selectBlueprint("CHATAIBLE_DATA_SEARCH");
                }
                updateDatasetId(undefined);
                updateArtifactId(undefined);
                updateContextSelectionPanelTab(undefined);
            }, className: styles.dataButton, active: blueprintId === "CHATAIBLE_DATA_SEARCH", isTransparentLoading: (isDatasetsLoading || isArtifactsLoading) && !hasFolderData, disabled: !hasFolderData, loadingText: "Checking for available data…" },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.dataButtonIconContainer },
                    React.createElement("div", { className: styles.dataButtonIcon },
                        React.createElement("img", { src: blueprintId === "CHATAIBLE_DATA_SEARCH"
                                ? checkedBox
                                : hasFolderData
                                    ? uncheckedBox
                                    : uncheckedBoxGray }))),
                "Auto-recommend context")))));
};
const ConfirmationModal = ({ showModal, updateShowModal, confirmationAction, updateConfirmationAction, handleAddContext, handleRemoveContext, updateHasConfirmed }) => {
    return (React.createElement(Dialog, { open: showModal, onOpenChange: () => {
            updateShowModal(false);
            updateConfirmationAction(undefined);
        } },
        React.createElement(DialogContent, { size: "md" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, `Confirm Agent Dataset`)),
            React.createElement("div", null, "Your agent already has data selected. Are you sure you'd like to change the selected data?"),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { type: "secondary", onClick: () => {
                        updateShowModal(false);
                        updateConfirmationAction(undefined);
                    }, className: "mr-auto" }, "Cancel"),
                React.createElement(Button, { type: "secondary", onClick: () => {
                        updateShowModal(false);
                        if (confirmationAction === "ADD") {
                            handleAddContext();
                        }
                        else if (confirmationAction === "REMOVE") {
                            handleRemoveContext();
                        }
                        updateHasConfirmed(true);
                    }, className: "ml-auto" }, "Confirm")))));
};
export default ContextSelectionButtons;
